/* eslint-disable max-len */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  getTimezone,
} from '../../selectors/common';
import {
  ODDS_HISTORY_MARKET_EXCEPTIONS,
  TENNIS_GAME_STEP,
} from '../../constants';
import { getDateTime } from '../../utils/common';
import MatchDescriptionTable from '../MatchTimeline/Soccer/MatchDescriptionTable';
import TennisMatchDetails from '../MatchTimeline/Tennis/TennisMatchDetails';
import MatchDescriptionOddsTable from '../OddsHistory1/Tennis/MatchDescriptionOddsTable';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
});

class OddsHistory2 extends Component {
  constructor() {
    super();

    this.state = {
      isDown: false,
      startX: '',
      scrollLeft: '',
    };
  }

  componentDidMount() {
    this.slider = document.querySelector('.odds__right--scrollable');
    this.slider.addEventListener('mousedown', this.mouseDownEvent);
    this.slider.addEventListener('mouseleave', this.mouseUpOrLeaveEvent);
    this.slider.addEventListener('mouseup', this.mouseUpOrLeaveEvent);
    this.slider.addEventListener('mousemove', this.mouseMoveEvent);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadedExcelFile !== this.props.downloadedExcelFile) {
      window.location.assign(this.props.downloadedExcelFile.url);
    }
  }

  componentWillUnmount() {
    this.slider.removeEventListener('mousedown', this.mouseDownEvent);
    this.slider.removeEventListener('mouseleave', this.mouseUpOrLeaveEvent);
    this.slider.removeEventListener('mouseup', this.mouseUpOrLeaveEvent);
    this.slider.removeEventListener('mousemove', this.mouseMoveEvent);
  }

  mouseDownEvent = (e) => {
    this.setState({
      isDown: true,
      startX: e.pageX - this.slider.offsetLeft,
      scrollLeft: this.slider.scrollLeft,
    });
  };

  mouseUpOrLeaveEvent = () => this.setState({ isDown: false });

  mouseMoveEvent = (e) => {
    if (!this.state.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = x - this.state.startX;
    this.slider.scrollLeft = this.state.scrollLeft - walk;
  };

  renderMatch = () => (
    this.props.isTennis
      ? (
        <TennisMatchDetails
          eventDetails={this.props.eventDetails}
        />
      )
      : (
        <div className="team-panel m-t-30">
          <span className="team-panel__txt">
            {this.props.eventDetails.teamHome.name}
            {' '}
            <span className="m-r-10 m-l-10">VS</span>
            {' '}
            {this.props.eventDetails.teamAway.name}
          </span>
        </div>
      )
  );

  renderDescTable = () => (
    this.props.isTennis
      ? (
        <MatchDescriptionOddsTable
          eventDetails={this.props.eventDetails}
        />
      )

      : (
        <MatchDescriptionTable
          eventDetails={this.props.eventDetails}
          leagues={this.props.leagues}
        />
      )
  );

  renderMatchDetails = () => this.props.oddsDetails.map((match) => {
    const timeArr = getDateTime(match.dateTime, this.props.getTimezone).split(':');
    timeArr.pop();
    const time = timeArr.join(':');
    return (
      this.props.isTennis
        ? (
          <tr key={match.dateTime}>
            <td>{time}</td>
            <td>{`Game ${match.gameId} ${TENNIS_GAME_STEP[match.gameStep]}`}</td>
            <td>
              {`${match.playerOneGameScore} - ${match.playerTwoGameScore}`}
            </td>
            <td>
              {`${match.playerOneSetScore} - ${match.playerTwoSetScore}`}
            </td>
          </tr>
        )
        : (
          <tr key={match.minuteMatch}>
            <td>{time}</td>
            <td>{`${match.minuteMatch}'`}</td>
            <td>{match.score}</td>
          </tr>
        )
    );
  });

  exportToExcel = () => {
    this.props.exportToExcel({
      matchId: this.props.matchId,
      markets: this.props.selectedMarkets,
    });
  };

  renderTitleLeftTable= () => (
    this.props.isTennis ? (
      <tr className="tr--primary">
        <th>Date</th>
        <th>Game</th>
        <th> Game Score</th>

        <th>Set Score</th>
      </tr>
    )
      : (
        <tr className="tr--primary">
          <th>Date</th>
          <th className="odds__table-time">
            Match
            <br />
            Minutes
          </th>
          <th className="odds__table-score">Score</th>
        </tr>
      )
  );

  renderLeftTable = () => (
    <div className="odds__left">
      <table className="odds__table">
        <thead>
          <tr className="tr--first">
            <th colSpan={this.props.numberOfTitleColumns} className="text-left">
              <button
                id="exportToExcel_OddsHistory2"
                type="button"
                className="btn btn-primary"
                onClick={this.exportToExcel}
              >
                Export to Excel
              </button>
              <Link
                to={this.props.oddsHistoryStep1Page}
                className="btn btn-secondary m-l-10"
              >
                Change Selected Markets
              </Link>
            </th>
          </tr>
          {this.renderTitleLeftTable()}
        </thead>
        <tbody className="bgwhite">
          {this.renderMatchDetails()}

        </tbody>
      </table>
    </div>
  );

  renderMarketsHeader = (selectedMarkets) => selectedMarkets.map((market) => {
    if (market && market.selections !== undefined) {
      return <th key={market.id}>{market.name}</th>;
    }
    return null;
  });

  renderMarketSelectionHeaders = (selectedMarkets) => selectedMarkets.map((market) => {
    if (market && market.selections !== undefined) {
      return (
        <th key={market.id}>
          <div className="table-f">
            {market.selections.map((selection) => (
              <div key={selection.id}>{selection.name}</div>
            ))}
          </div>
        </th>
      );
    }
    return null;
  });

  renderMarketOdds = (selectedMarkets) => this.props.oddsDetails.map((oddDetail) => {
    const { markets } = oddDetail;
    return (
      <tr key={oddDetail.minuteMatch || oddDetail.dateTime}>
        {selectedMarkets.map((market, idx) => {
          if (market && market.selections !== undefined) {
            const { id } = market;
            return (
              <td key={id}>
                <div className="table-f">
                  {market.selections.map((selection) => (
                    <div key={`${selection.id}`}>
                      {markets[id]?.[selection.id]?.toFixed(2) || '-'}
                    </div>
                  ))}
                </div>
              </td>
            );
          }
          const moKey = `market-odds-${idx}`;
          return <td key={moKey}>-</td>;
        })}
      </tr>
    );
  });

  constructMarkets = (selectedMarketIds, displayedMarketIds) => {
    const markets = [];
    for (let i = 0; i < selectedMarketIds.length; i += 1) {
      const currentMarketId = selectedMarketIds[i];

      const marketsToBeDisplayedDetails = this.props.oddsHistoryTemplate.find((market) => market.id === currentMarketId);
      const marketsToBeDisplayed = marketsToBeDisplayedDetails?.marketIds;

      if (ODDS_HISTORY_MARKET_EXCEPTIONS?.includes(currentMarketId)) {
        for (let k = 0; k < marketsToBeDisplayed.length; k += 1) {
          if (displayedMarketIds?.includes(marketsToBeDisplayed[k]?.toString())) {
            markets.push(marketsToBeDisplayed[k]);
          }
        }
      } else if (marketsToBeDisplayedDetails?.useMainMarketId) {
        markets.push(marketsToBeDisplayedDetails?.marketIds?.[0]);
      } else {
        for (let j = 0; j < marketsToBeDisplayed?.length; j += 1) {
          markets.push(marketsToBeDisplayed[j]);
        }
      }
    }
    return markets;
  };

  renderMarketOddsTable = () => {
    const marketsDisplayedIds = Object.keys(this.props.marketsDisplayed);

    const constructedMarkets = this.constructMarkets(this.props.selectedMarkets, marketsDisplayedIds);
    const selectedMarkets = constructedMarkets.map((marketId) => this.props.markets.find((market) => market.id === parseInt(marketId)));
    return (
      <table className="odds__table odds__table--dark">
        <thead>
          <tr className="tr--first tr--secondary">
            {this.renderMarketsHeader(selectedMarkets)}
          </tr>
          <tr className="tr--primary">
            {this.renderMarketSelectionHeaders(selectedMarkets)}
          </tr>
        </thead>
        <tbody>
          {this.renderMarketOdds(selectedMarkets)}
        </tbody>
      </table>
    );
  };

  renderOddsHistory = () => {
    if (this.props.eventDetails) {
      return (
        <>
          {this.renderDescTable()}
          {this.renderMatch()}
          <div className="odds m-t-30">
            {this.renderLeftTable()}
            <div className="odds__right odds__right--scrollable">{this.renderMarketOddsTable()}</div>
          </div>
        </>
      );
    }
    return null;
  };

  render() {
    return (
      <>
        {this.renderOddsHistory()}
      </>
    );
  }
}

export default connect(mapToProps)(OddsHistory2);
